// extracted by mini-css-extract-plugin
export default {"history-table-container":"_history-table-container_ptlrgr","history-table-links":"_history-table-links_1dFu6o","history-table":"_history-table_AMfVSd"};